export default function StarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M9.34462 13.901L13.2849 16.3974C13.7886 16.7165 14.4139 16.2419 14.2644 15.654L13.126 11.1756C13.0939 11.0509 13.0977 10.9197 13.137 10.797C13.1762 10.6743 13.2492 10.5652 13.3477 10.4822L16.8811 7.54132C17.3453 7.1549 17.1057 6.38439 16.5092 6.34568L11.8949 6.0462C11.7706 6.03732 11.6514 5.99332 11.5511 5.91931C11.4509 5.84531 11.3737 5.74435 11.3286 5.62819L9.60765 1.29436C9.56087 1.17106 9.47769 1.06492 9.36915 0.990017C9.26062 0.915115 9.13187 0.875 9 0.875C8.86813 0.875 8.73938 0.915115 8.63085 0.990017C8.52232 1.06492 8.43914 1.17106 8.39236 1.29436L6.6714 5.62819C6.6263 5.74435 6.54914 5.84531 6.4489 5.91931C6.34865 5.99332 6.22944 6.03732 6.10515 6.0462L1.49078 6.34568C0.894294 6.38439 0.654664 7.1549 1.11894 7.54132L4.65232 10.4822C4.75079 10.5652 4.82383 10.6743 4.86305 10.797C4.90226 10.9197 4.90606 11.0509 4.874 11.1756L3.81824 15.3288C3.63889 16.0343 4.38929 16.6038 4.99369 16.2209L8.65539 13.901C8.75837 13.8354 8.87792 13.8006 9 13.8006C9.12208 13.8006 9.24163 13.8354 9.34462 13.901V13.901Z"
        stroke="#5E718D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
